import { FC } from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';
import { pluralizeByCount } from '../../lib/util/DataHelpers';

import GoBackButton from '../../components/GoBackButton/GoBackButton';
import Grid from '../../components/Grid/Grid';
import LatestNews from '../../components/News/LatestNews/LatestNews';
import useIsMobile from '../hooks/useIsMobile';

import EarningsTable from './components/EarningsTable/EarningsTable';
import { EarningsCalendarInternalProps } from './EarningsCalendarInternal.types';

import styles from './EarningsCalendarInternal.module.scss';

const EarningsCalendarInternal: FC<EarningsCalendarInternalProps> = ({
  isAce,
  titleRef,
  onGoBack,
  ...tableProps
}: EarningsCalendarInternalProps): JSX.Element => {
  const { isMobile } = useIsMobile();

  const extraChildren = () => !isMobile && (
    <div className={styles.wrapperSecondSection}>
      <LatestNews />
    </div>
  );

  return (
    <Grid extraChildren={extraChildren()}>
      {!isMobile && (
        <div className={styles.goBackButton}>
          <GoBackButton onBackBtnPress={onGoBack} />
        </div>
      )}
      <div
        className={classNames(styles.wrapperLayout, {
          [styles.wrapperLayoutMobile]: isMobile,
          [styles.wrapperLayoutAce]: isAce,
        })}
      >
        <div className={styles.wrapperFirstSection}>
          <div className={styles.titleWrapper}>
            <h6 ref={titleRef} className={classNames(styles.title, { [styles.titleMobile]: isMobile })}>
              {lang.discoverEarningsCalendarTitle()}
            </h6>
            {tableProps.totalElements > 0 && !isMobile && (
              <div className={styles.lengthEvents}>
                <span>
                  {`(${tableProps.totalElements} ${pluralizeByCount(
                    tableProps.totalElements,
                    lang.commonDiscoverCalenderItem(),
                    lang.commonDiscoverCalenderItems(),
                  )})`}
                </span>
              </div>
            )}
          </div>
          <EarningsTable {...tableProps} />
        </div>
      </div>
    </Grid>
  );
};

export default EarningsCalendarInternal;
